import React from 'react';
import './HealthTwoAppDownload.scss';

const HealthTwoAppDownload = () => {
  return (
    <section className="health-two-app-download">
      <div className="app-download-container">
        <div className="app-left">
          <h2>
            Download Our <br />
            <span className="highlight">Healthcare</span> <br />
            App for Easy Access
          </h2>
          <div className="store-buttons">
            <img src="/assets/img/health/healthTwo/appstore.png" alt="App Store" />
            <img src="/assets/img/health/healthTwo/gp.png" alt="Google Play" />
          </div>
        </div>
        <div className="app-right">
          <img src="/assets/img/health/healthTwo/imageapp-removebg-preview.png" alt="Healthcare App UI" />
        </div>
      </div>
    </section>
  );
};

export default HealthTwoAppDownload;
